import { render } from "./Group9.vue?vue&type=template&id=1ebf72b1&scoped=true"
import script from "./Group9.vue?vue&type=script&lang=js"
export * from "./Group9.vue?vue&type=script&lang=js"

import "./Group9.vue?vue&type=style&index=0&id=1ebf72b1&lang=css"
import "./Group9.vue?vue&type=style&index=1&id=1ebf72b1&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebf72b1"]])

export default __exports__